import { DateUtils } from '../../../utils/DateUtils';
import { TrackingUtils } from '../../../utils';
import { CalendarType } from '../../../models';

const getSelectedDayColor = ({ dateStr, dateNotRequested, price, cheapestDays }) => {
    let selectedDayColor;
    if (dateNotRequested) {
        selectedDayColor = 'NA';
    } else {
        if (price) {
            if (cheapestDays.find((dates) => dates === dateStr)) {
                selectedDayColor = 'GR';
            } else {
                selectedDayColor = 'GY';
            }
        } else {
            selectedDayColor = 'LD';
        }
    }
    return selectedDayColor;
};

const getSelectedDayWithPrice = (dateRequested, price) => {
    return dateRequested && price ? 1 : 0;
};

export const FaresProviderOnClick = ({ departurePrices, returnPrices, cheapestDepartureDays,
    cheapestReturnDays, lastDateRequested }) => (date, calendarType) => {
    const dateStr = DateUtils.toString(date);
    let price;
    let cheapestDays;
    if (calendarType === CalendarType.RETURN) {
        price = returnPrices[dateStr];
        cheapestDays = cheapestReturnDays;
    } else {
        price = departurePrices[dateStr];
        cheapestDays = cheapestDepartureDays;
    }
    const dateNotRequested = date.getTime() >= lastDateRequested;
    const selectedDayWithPrice = getSelectedDayWithPrice(!dateNotRequested, price);
    const selectedDayColor = getSelectedDayColor({ dateStr, dateNotRequested, price, cheapestDays });

    TrackingUtils.trackEvent({ action: TrackingUtils.ACTION.FLIGHTS, label: `click_calendar_${selectedDayWithPrice}_${selectedDayColor}` });
};
